import React, { useEffect, useState } from "react";
import api from "./api";
import { Card, Button, BackButton } from "./ui";
import { Detail, actCat } from "./Activities";

function fmtDate(d) {
  if (!d) return "";
  try {
    return new Date(`${d}T00:00:00`).toLocaleDateString("es", { weekday: "short", day: "numeric", month: "short" });
  } catch {
    return d;
  }
}

export default function MyActivities({ onBack, onGoActivities }) {
  const [items, setItems] = useState(null);
  const [selected, setSelected] = useState(null);

  const load = () => {
    api.activities.my().then(setItems).catch(() => setItems([]));
  };
  useEffect(load, []);

  if (selected) {
    return (
      <div className="mx-auto max-w-5xl px-4 py-5 sm:px-6">
        <Detail
          activity={selected}
          onBack={() => {
            setSelected(null);
            load();
          }}
        />
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-5xl px-4 py-5 pb-28 sm:px-6" data-testid="my-activities-screen">
      <BackButton onClick={onBack} label="Volver a Perfil" testId="my-activities-back" />
      <h1 className="mt-3 text-2xl font-bold text-[#0B2D4D]">Mis Actividades 📅</h1>
      <p className="mt-1 text-sm text-slate-500">Actividades a las que te uniste con tu peludito.</p>

      {items === null ? (
        <p className="mt-8 text-center text-sm text-slate-400">Cargando…</p>
      ) : items.length === 0 ? (
        <div className="mt-10 text-center" data-testid="my-activities-empty">
          <div className="text-5xl">🐾</div>
          <p className="mt-3 text-sm text-slate-500">Aún no te has unido a ninguna actividad PawCita 🐾</p>
          <Button className="mt-4" onClick={onGoActivities} data-testid="my-activities-go-activities">
            Ver actividades
          </Button>
        </div>
      ) : (
        <div className="mt-4 grid gap-3 sm:grid-cols-2">
          {items.map((a) => {
            const info = actCat(a.category);
            return (
              <Card
                key={a.activity_id}
                data-testid={`my-activity-card-${a.activity_id}`}
                className="cursor-pointer overflow-hidden transition hover:shadow-lg"
                onClick={() => setSelected({ ...a, id: a.activity_id })}
              >
                <div className="flex h-24 w-full items-center justify-center bg-gradient-to-br from-[#67D5B5]/25 to-[#0B2D4D]/10 text-4xl">
                  {a.image ? <img src={a.image} alt={a.title} className="h-full w-full object-cover" /> : info.emoji}
                </div>
                <div className="p-4">
                  <div className="flex items-center gap-2">
                    <span className="text-xs font-semibold text-emerald-700">{info.emoji} {info.label}</span>
                    <span className="rounded-full bg-emerald-50 px-2 py-0.5 text-[11px] font-bold text-emerald-700">Inscrito</span>
                  </div>
                  <h3 className="mt-1 text-base font-bold leading-snug text-[#0B2D4D] break-words">{a.title}</h3>
                  <p className="mt-1 text-xs font-semibold text-slate-500">📅 {fmtDate(a.date)} · 🕐 {a.time}</p>
                  <p className="mt-0.5 text-xs text-slate-500">📍 {a.location}{a.city ? ` · ${a.city}` : ""}</p>
                  <p className="mt-1 text-xs text-slate-500">🐶 {a.dog_name}</p>
                  <p className="mt-2 text-xs font-bold text-[#FF5C5C]">Ver detalle, chat y calendario ›</p>
                </div>
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );
}
